import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlightText' })
export class HighlightTextPipe implements PipeTransform {
    private domSanitizer: DomSanitizer = inject(DomSanitizer);

    transform(value: string | undefined): SafeHtml {
        if (!value) return '';

        const escaped = value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        const highlighted = escaped.replace(
            /\*\*(.*?)\*\*/g,
            '<span class="nw-text-highlight">$1</span>'
        );

        return this.domSanitizer.bypassSecurityTrustHtml(highlighted);
    }
}
